(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["kdb-studio-splashScreen"] = factory();
	else
		root["kdb-studio-splashScreen"] = factory();
})(this, () => {
return 